<template>
  <highcharts :options="chartOptions" :ref="barchart_id"></highcharts>
</template>

<script>
import { Chart } from "highcharts-vue";
export default {
  name: "bar_chart_highchart",
  props: {
    dataset: Array,
    height: {
      type: String,
      default: function () {
        return null;
      },
    },
    yLabel: {
      type: String,
      default: function () {
        return "Mentions";
      },
    },
    barchart_id: {
      type: String,
      default: function () {
        return "barchart-element";
      },
    },
    is_clickable: {
      type: Boolean,
      default: function () {
        return true;
      },
    },
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      data: this.dataset,
      chartOptions: {},
    };
  },
  methods: {
    loadChart: function () {
      let self = this;
      this.chartOptions = {
        chart: {
          type: "column",
          backgroundColor: "transparent",
          height: self.height ? self.height : "",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },
        xAxis: {
          type: "category",
          labels: {
            rotation: -45,
            style: {
              fontSize: "13px",
              fontFamily: "Verdana, sans-serif",
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: self.yLabel,
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            cursor: "pointer",
            events: {
              click: function (event) {
                if (self.is_clickable == true) {
                  let q = event.point.name;
                  let params = self.$route.query;
                  params.q = q;
                  self.$router.push({ path: "/posts", query: params });
                }
              },
            },
          },
        },
        tooltip: {
          pointFormat: "Jumlah Mention: <b>{point.y}</b>",
        },
        series: [
          {
            name: "Mentions",
            data: this.data,
            dataLabels: {
              enabled: true,
              rotation: -90,
              color: "#FFFFFF",
              align: "right",
              format: "{point.y}",
              y: 10,
              style: {
                fontSize: "13px",
                fontFamily: "Verdana, sans-serif",
              },
            },
          },
        ],
      };
    },
  },
  mounted: function () {
    if (this.data != null) {
      this.loadChart();
    }
  },
};
</script>